import React from "react";

import { connect } from "react-redux";
import Evaluation from "./index";
import {
  updateEvaluation,
  evaluationState
} from "../../modules/evaluation/actions";
import { fetchResult } from "../../modules/results/actions";
import { changeLanguage } from "../../modules/preference/actions";
import { START_EVALUATION } from "../../modules/evaluation/constants";
import { Link } from "react-router-dom";
import { Button } from "antd";

import Loader from "../../components/Loader";

class EvaluationContainer extends React.Component {
  componentWillMount() {
    const { id } = this.props.match.params;
    if (id) {
      this.props.fetchResult(id);
      this.props.evaluationState(START_EVALUATION);
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const noAccesContainer = (
      <div className="noAccessContainer">
        <div>
          <div>You have already filled this</div>
          <div>
            <Link to="/">
              <Button>Go back to website</Button>
            </Link>
          </div>
        </div>
      </div>
    );

    const type = window.location.pathname.split("/")[1];

    switch (type) {
      case "profile":
        if (this.props.user.hasFilledTa) {
          return noAccesContainer;
        }
        break;
      case "twentyfivesections":
        if (this.props.user.hasFilled24) {
          return noAccesContainer;
        }
        break;
      case "twelvesections":
        if (this.props.user.hasFilled12) {
          return noAccesContainer;
        }
        break;
      default:
        
    }

    return this.props ? (
      <Evaluation
        {...this.props}
        updateEvaluation={this.props.updateEvaluation}
      />
    ) : (
      <Loader></Loader>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    step: state.evaluation.step,
    result: state.results.result,
    language: state.preference.language
  };
}

const mapActionsToProps = {
  fetchResult,
  updateEvaluation,
  evaluationState,
  changeLanguage
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(EvaluationContainer);



// WEBPACK FOOTER //
// ./src/pages/Evaluation/container.js